import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function IndexSectionPricing9() {
    const [isYearly, setIsYearly] = useState(false);

    const plans = [
        {
            name: "Individual",
            monthlyPrice: 15.00,
            features: [
                "Two week free trial",
                "Unlimited storage",
                "AI object fetching and tagging",
                "Sorting templates and tags",
                "Storage of documents, pictures, videos and audio files"
            ],
            textColor: "text-gray-500"
        },
        {
            name: "Family",
            monthlyPrice: 40.00,
            features: [
                "Up to 5 members under one subscription",
                "All Individual features",
                "Share with family members"
            ],
            textColor: "text-gray-500"
        },
        {
            name: "Business",
            monthlyPrice: null, // Contact sales
            features: [],
            textColor: "text-gray-500"
        }
    ];

    const formatPrice = (price) => {
        if (price === null) return "---";
        const displayPrice = isYearly ? (price * 12).toFixed(0) : price.toFixed(2);
        return displayPrice;
    };

    return (
        <React.Fragment>
            <>
                <section id="pricing" className="relative py-20">
                    <img className="hidden lg:block absolute top-0 left-0 mt-64" src="zeus-assets/icons/dots/blue-dot-left-bars.svg" alt="" />
                    <img className="hidden lg:block absolute top-0 right-0 mt-40" src="zeus-assets/icons/dots/yellow-dot-right-shield.svg" alt="" />
                    <div className="container px-4 mx-auto">
                        <div className="max-w-2xl mx-auto mb-20 text-center">
                            <h2 className="mt-8 mb-10 text-4xl font-semibold font-heading">Pricing</h2>
                            <p className="mb-16 text-xl text-gray-500">Choose the plan that works best for you. All plans include our core AI-powered organization features.</p>
                            <div className="max-w-max mx-auto p-1 bg-gray-50 rounded">
                                <button 
                                    onClick={() => setIsYearly(false)}
                                    className={`px-10 py-4 text-sm font-semibold leading-normal rounded transition duration-200 ${
                                        !isYearly ? 'bg-white text-gray-900' : 'text-gray-500 hover:text-gray-900'
                                    }`}
                                >
                                    Monthly
                                </button>
                                <button 
                                    onClick={() => setIsYearly(true)}
                                    className={`px-10 py-4 text-sm font-semibold leading-normal rounded transition duration-200 ${
                                        isYearly ? 'bg-white text-gray-900' : 'text-gray-500 hover:text-gray-900'
                                    }`}
                                >
                                    Yearly
                                </button>
                            </div>
                        </div>
                        <div className="flex flex-wrap items-stretch -mx-3">
                            {plans.map((plan, index) => (
                                <div key={index} className="w-full lg:w-1/3 px-3 mb-6 lg:mb-0 flex">
                                    <div className="pt-12 pb-8 px-8 border rounded-xl lg:text-center flex flex-col w-full">
                                        <h3 className={`mb-6 font-medium ${plan.textColor}`}>{plan.name}</h3>
                                        <div className="flex lg:justify-center mb-8">
                                            <span className="self-start inline-block mr-1 text-xl font-semibold text-gray-500">$</span>
                                            <p className="self-end text-5xl font-semibold font-heading">
                                                {formatPrice(plan.monthlyPrice)}
                                            </p>
                                            <span className="self-end text-sm font-medium text-gray-500 mb-2">
                                                {plan.monthlyPrice !== null ? (isYearly ? '/year' : '/month') : ''}
                                            </span>
                                        </div>
                                        {plan.features && plan.features.length > 0 && (
                                            <ul className="mb-6 text-left flex-grow">
                                                {plan.features.map((feature, featureIndex) => (
                                                    <li key={featureIndex} className="flex items-center py-4 border-b">
                                                        <svg className="mr-2" width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M5.67 0H14.34C17.73 0 20 2.38 20 5.92V14.091C20 17.62 17.73 20 14.34 20H5.67C2.28 20 0 17.62 0 14.091V5.92C0 2.38 2.28 0 5.67 0ZM9.43 12.99L14.18 8.24C14.52 7.9 14.52 7.35 14.18 7C13.84 6.66 13.28 6.66 12.94 7L8.81 11.13L7.06 9.38C6.72 9.04 6.16 9.04 5.82 9.38C5.48 9.72 5.48 10.27 5.82 10.62L8.2 12.99C8.37 13.16 8.59 13.24 8.81 13.24C9.04 13.24 9.26 13.16 9.43 12.99Z" fill="#45C1FF" />
                                                        </svg>
                                                        <p className="font-medium">{feature}</p>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                        <div className="mt-auto">
                                            {plan.name === 'Business' ? (
                                                <a className="inline-block py-4 w-full text-sm text-center font-medium leading-normal text-white rounded bg-red-400 hover:bg-red-300 transition duration-200" href="#contact">
                                                    Contact Sales
                                                </a>
                                            ) : (
                                                <Link to="/register" className="inline-block py-4 w-full text-sm text-center font-medium leading-normal text-white rounded bg-red-400 hover:bg-red-300 transition duration-200">
                                                    Try it now
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <p className="mt-6 text-center text-xs text-gray-500">
                            Usage beyond 500 GB will be metered at $0.02/GB.
                        </p>
                    </div>
                </section>
            </>
        </React.Fragment>
    );
}